export const requiredFieldsTeacher = [
    { key: 'ma_nhan_su', label: 'Mã nhân sự' },
    { key: 'month', label: 'Month' },
    { key: 'phat', label: 'Phạt' },
    { key: 'thu_coc', label: 'Thu Cọc' },
    { key: 'thu_nhap_day_hoc', label: 'Thu nhập dạy học' },
    { key: 'thu_nhap_khac', label: 'Thu nhập khác' },
    { key: 'thu_nhap_thuc_nhan', label: 'Thu thập thực nhận' },
    { key: 'trich_thue_thu_nhap_ca_nhan', label: 'Trich thuế cá nhân' },
    { key: 'thuong', label: 'Thưởng' },
    { key: 'tong_cac_khoan_thu_nhap', label: 'Tổng thu nhập' },
    { key: 'tong_cac_khoan_tru_thu_nhap', label: 'Tổng trừ thu nhập' },
    { key: 'tra_coc', label: 'Trả cọc' },
    { key: 'year', label: 'Year' },
];

export const numberFieldsTeacher = [
    { key: 'year', label: 'Year' },
    { key: 'month', label: 'Month' },
    { key: 'ma_nhan_su', label: 'Mã nhân sự' },
    { key: 'thu_nhap_thuc_nhan', label: 'Thu nhập thực nhận' },
    { key: 'tong_cac_khoan_thu_nhap', label: 'Tổng thu nhập' },
]

export const requiredFieldsTeacherDetail = [
    { key: 'don_gia', label: 'Đơn giá' },
    { key: 'ma_nhan_su', label: 'Mã nhân sự' },
    { key: 'month', label: 'Month' },
    { key: 'thanh_tien', label: 'Thành tiền' },
    { key: 'type_salary', label: 'Loại phiếu lương' },
    { key: 'year', label: 'Year' },
];

export const numberFieldsTeacherDetail = [
    { key: 'don_gia', label: 'Đơn giá' },
    { key: 'ma_nhan_su', label: 'Mã nhân sự' },
    { key: 'month', label: 'Month' },
    { key: 'thanh_tien', label: 'Thành tiền' },
    { key: 'type_salary', label: 'Loại phiếu lương' },
    { key: 'year', label: 'Year' },
];

export const headerSalaryTeacher = ['year','month', 'ma_nhan_su', 'trung_tam', 'thu_nhap_day_hoc', 'tra_coc', 'thu_nhap_khac', 'thuong', 'tong_cac_khoan_thu_nhap', 'thu_coc', 'phat', 'trich_thue_thu_nhap_ca_nhan', 'tong_cac_khoan_tru_thu_nhap', 'thu_nhap_thuc_nhan'];
export const headerSalaryDetailTeacher = ['year','month','ma_nhan_su', 'type_salary', 'ten_lop', 'co_so', 'so_cong', 'don_gia', 'thanh_tien'];









